import { render } from "./About.vue?vue&type=template&id=c129dd5e&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=c129dd5e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c129dd5e"

export default script